import { Component, inject, signal } from '@angular/core';
import { RouterOutlet } from '@angular/router';
import { Header } from './layout/header/header';
import { ClientThemeService } from './core/services/client-theme.service';

@Component({
  selector: 'app-root',
  imports: [RouterOutlet, Header],
  templateUrl: './app.html',
  styleUrl: './app.scss',
})
export class App {
  protected readonly title = signal('automalink-front-end');

  // Injetado para instanciar o serviço e ativar seu effect() reativo de tema
  private readonly clientThemeService = inject(ClientThemeService);
}
